import { styled } from "@mui/material";
import { FaBars, FaCopy } from "react-icons/fa";

export const TopBarContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "22px 20px",
  // backgroundColor: "#fff",
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  position: 'sticky',
  top: 0,
  zIndex: 1001,
});

export const TopBarLeft = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "20px",
});

export const TopBarName = styled("div")({
  "& strong": {
    fontSize: "16px",
    color: "#333",
  },
});
export const DropdownMenu = styled("div")({
  position: "absolute",
  right: "0",
  top: "100%",
  backgroundColor: "#fff",
  border: "1px solid #e0e0e0",
  borderRadius: "4px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  zIndex: "1000",
  minWidth: "150px",
  //overflow: "hidden",
});

export const DropdownItem = styled("div")({
  padding: "8px 16px",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
});

export const TopBarValidity = styled("div")({
  "& strong": {
    fontWeight: 800,
    marginRight: "5px",
    color: "#666",
  },
  color: "#666",
});

export const TopBarRight = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "20px",
});

export const TopBarIcon = styled("div")({
  color: "#6FA2DC",
  fontSize: "18px",
  cursor: "pointer",
  transition: "color 0.2s",
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  "&:hover": {
    color: "#333",
  },
});

export const MenuWrapper = styled("div")({
  overflowY: 'auto',
  height: '100%',

  // Scrollbar styles
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
});

export const SidebarContainer = styled("div")((props) => ({
  width: props.collapsed ? "0px" : "250px",
  transition: "width 0.3s ease",
  overflow: "hidden",
  height: "100vh",
  boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
  zIndex: 100,
  position: "fixed",
  top: "0px",
  background: "linear-gradient(135deg, #0E374F 0%, #156C9C 100%)",
}));




// export const SidebarContainer = styled("div")((props) => ({
//   width: ${(props) => (props.collapsed ? "60px" : "250px")};
//   transition: width 0.3s ease;
//   overflow: hidden;
//   // other styles
// }));


export const SidebarHeader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  // padding: "1rem",
  padding: '8px 12px 8px 6px',
  color:'#fff',
  borderBottom: '1px solid rgb(221, 221, 221)',
  // backgroundColor: "#fff",
  background: "linear-gradient(311deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
});

export const HeaderTitle = styled("h3")({
  margin: 0,
  fontWeight: "bold",
  fontSize: "1rem",
});

export const HamburgerIcon = styled(FaBars)({
  cursor: "pointer",
  fontSize: "1rem",
});

export const MenuItem = styled("div")({
  // backgroundColor: "#1F4A7C",
  color: "#fff",
  padding: "0.75rem 1rem",
  fontSize: ".9rem",
  margin: "0.25rem 0",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
  fontWeight: "bold",
});

export const SubMenuItem = styled("div")({
  padding: "0.5rem 1rem 0.5rem 2rem",
  color: "#fff",
  // backgroundColor: "#ADCAEB",
  fontSize: "0.75rem",
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  "&:not(:last-child)": {
    borderBottom: "1px solid rgba(0,0,0,0.1)", // optional subtle separator
  },
});
export const NestedSubMenuItem = styled("div")({
  padding: "0.5rem 1rem 0.5rem 2rem",
  // backgroundColor: "#ADCAEB",
  color: "#fff",
  fontSize: "0.75rem",
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  "&:not(:last-child)": {
    borderBottom: "1px solid rgba(0,0,0,0.1)", // optional subtle separator
  },
})

export const CopyIcon = styled(FaCopy)({
  cursor: "pointer",
  fontSize: "0.9rem",
});

export const DashboardLayout = styled("div")(({ isObpsRoute }) => ({
  display: "flex",
  minHeight: "100vh",
  width: "100%",
  //overflow: "auto",
  // marginTop: isObpsRoute ? "-5rem" : "0",
}));
export const MainContent = styled("div")((props) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  width: "75%",
  minHeight: "100vh",
  paddingLeft: props.collapsed ? "0px" : "250px",
}));
export const MenuItemTitle = styled("span")({
  fontWeight: "normal",
});

export const FileInfoStrip = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  backgroundColor: "#fff",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  borderRadius: "4px",
  margin: "8px 0",
  position: 'sticky',
  top: 40,
  zIndex: 1000,
});

export const FileNo = styled("span")({
  flex: 1,
  textAlign: "left",
});

export const RiskType = styled("span")((props) => ({
  textAlign: "center",
  fontWeight: "bold",
  color: props.riskType === "High Risk" ? "#d32f2f" : "#388e3c",
  padding: "4px 8px",
  borderRadius: "6px",
}));

export const Status = styled("span")((props) => ({
  textAlign: "center",
  backgroundColor: "#4caf50",
  color: "white",
  padding: "4px 8px",
  borderRadius: "6px",
  fontSize: "0.8rem",
}));

export const Owner = styled("div")({
  flex: 1,
  textAlign: "right",
  fontWeight: "bold",
});

export const AuthInfoStrip = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  backgroundColor: "#fff",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  borderRadius: "4px",
  margin: "8px 0",
});

export const AuthorityName = styled("span")({
  flex: 1,
  textAlign: "left",
  fontWeight: "500",
});

export const InfoText = styled("span")({
  flex: 1,
  textAlign: "center",
  color: "red",
  fontStyle: "italic",
});

export const ActionButton = styled("button")({
  backgroundColor: "#2862A4",
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "8px 16px",
  margin: "0 4px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "&:hover": {
    backgroundColor: "#1e4a7e",
  },
});

export const PortalWrapper = styled("div")(() => ({
  boxSizing: "border-box",
  //overflow: "hidden",
}));

// export const NotificationBadge = styled('span')(() => ({
//   position: 'relative',
//   backgroundColor:'rgb(235, 46, 46)',
//   color: '#fff',
//   borderRadius: '50%',
//   width: '15px',
//   height: '15px',
//   top: '-6px',
//   // left: '-30px',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   fontSize: '10px',
//   fontWeight: 'bold'
// }));


export const NotificationBadge = styled('span')(() => ({
  position: 'absolute',
  top: '-4px',       // adjust top to control the vertical position
  right: '-4px',     // adjust right to control the horizontal position
  backgroundColor: 'rgb(235, 46, 46)',
  color: '#fff',
  borderRadius: '50%',
  width: '15px',
  height: '15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '10px',
  fontWeight: 'bold',
}));

